import { DatePickerInput, type DatePickerInputProps } from "@mantine/dates"
import { icons } from ".."

interface IProps extends Omit<DatePickerInputProps, "value" | "onChange"> {
  value?: string | number | null
  onChange?: (value: any) => void
  resultFormat?: "number" | "string"
}

export function AppDateInput({ onChange, value, resultFormat, ...props }: IProps) {
  return (
    <DatePickerInput
      w="100%"
      valueFormat="YYYY-MM-DD"
      leftSection={<icons.Calendar />}
      value={value ? new Date(value) : null}
      onChange={(value: any) => {
        if (value) value = resultFormat == "number" ? Date.parse(`${value}T00:00:00Z`) : value
        onChange?.(value)
      }}
      {...props}
    />
  )
}
